import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';

// import main components to map to routes
import { AppContainer as App } from './modules/app/components/App';
import { UnsupportedBrowserContainer as UnsupportedBrowser } from './modules/app/components/UnsupportedBrowser';
import { ForgotPasswordContainer as ForgotPassword } from './modules/login/components/ForgotPassword';
import { LaunchpadContainer as Launchpad } from './modules/launchpad/components/Launchpad';
import { LaunchpadErrorContainer as LaunchpadError } from './modules/launchpad/components/LaunchpadError';
import { LaunchQuestionnaireContainer as LaunchQuestionnaire } from './modules/questionnaire/components/LaunchQuestionnaire';
import { LoginContainer as Login } from './modules/login/components/Login';
import { LogoutContainer as Logout } from './modules/login/components/Logout';
import { LogoutSsoContainer as LogoutSso } from './modules/login/components/LogoutSso';
import { MobileSsoLoginContainer as MobileSsoLogin } from './modules/login/components/MobileSsoLogin';
import { MobileSsoLoginSuccessContainer as MobileSsoLoginSuccess } from './modules/login/components/MobileSsoLoginSuccess';
import { WebSsoLoginContainer as WebSsoLogin } from './modules/login/components/WebSsoLogin';
import { OAuthContainer as OAuth } from './modules/login/components/OAuth';
import { PasswordResetContainer as PasswordReset } from './modules/login/components/PasswordReset';
import { PreferencesContainer as Preferences } from './modules/preferences/components/Preferences';
import { QuestionsAndAnswersContainer as QuestionsAndAnswers } from './modules/questionnaire/components/QuestionsAndAnswers';
import { RegisterUserContainer as RegisterUser } from './modules/register/components/RegisterUser';
import { SelectTargetLanguageContainer as SelectTargetLanguage } from './modules/login/components/SelectTargetLanguage';
import { SsoErrorContainer as SsoError } from './modules/login/components/SsoError';
import { SsoLoginContainer as SsoLogin } from './modules/login/components/SsoLogin';
import { SetLocaleAndRedirectContainer as SetLocaleAndRedirect } from './modules/app/components/SetLocaleAndRedirect';

export const Router = ({ history }) => (
  <ConnectedRouter history={history}>
    <App>
      <Switch>
        <Route
          exact path="/"
          component={({ location }) => (
            <Redirect
              to={{
                ...location,
                pathname: location.pathname.replace(/\//, '/login'),
              }}
            />
          )}
        />
        <Route path="/locale/:localId" component={SetLocaleAndRedirect} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/launchpad/error" component={LaunchpadError} />
        <Route path="/launchpad" component={Launchpad} />
        <Route path="/login" component={Login} />
        <Route path="/logout" component={Logout} />
        <Route path="/logoutsso" component={LogoutSso} />
        <Route path="/mobilessologin" component={MobileSsoLogin} />
        <Route path="/mobilessologinsuccess" component={MobileSsoLoginSuccess} />
        <Route path="/webssologin" component={WebSsoLogin} />
        <Route path="/oauth" component={OAuth} />
        <Route path="/objectives/start" component={LaunchQuestionnaire} />
        <Route path="/objectives/questions" component={QuestionsAndAnswers} />
        <Route path="/preferences" component={Preferences} />
        <Route path="/register/:user_guid" component={RegisterUser} />
        <Route path="/reset_password/:reset_uuid" component={PasswordReset} />
        <Route path="/select-language" component={SelectTargetLanguage} />
        <Route path="/ssoerror/:sso_error" component={SsoError} />
        <Route path="/ssologin" component={SsoLogin} />
        <Route path="/unsupported" component={UnsupportedBrowser} />
        <Route path="/*" render={() => <Redirect to="/login" />} />
      </Switch>
    </App>
  </ConnectedRouter>
);



// WEBPACK FOOTER //
// ./src/routes.js